<template>
  <div>
    <CrudList
        title="Precio Sugerido"
        storeName="Suggested_prices"
        labelAddNew="Suggested_prices"
        :canAdd="false"
        :canEdit="true"
        :canDelete="false"
        sortable
        next-link="/admin/prices/edit/general"
        :breadcrumbs="[
          {
            text: 'Finanzas',
            disabled: false,
            href: '/admin/suggested_prices'
          },
          {
            text: 'Precio Sugerido',
            disabled: false,
            href: '#'
          },
          
        ]"
    />
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  name: "SuggestedPriceList", // opcional, pero recomendable
  components: { CrudList },
  data() {
    return {
      offsetTop: 0,
    };
  },
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
  },
};
</script>
